import { DATE_FORMAT, DATE_REPRESENTATION } from '../constants';
import { formatDate } from './formatCalendarTime';
import toDate from './toDate';

const { LONG, NUMERIC } = DATE_REPRESENTATION;

export default function formatDateRange(intl, start, end) {
  start = toDate(start);
  end = toDate(end);

  // For non-US locales, instead of trying to do an optimal "greatest difference" format,
  // we’ll just do full date range with "short" formats.
  if (intl.locale !== 'en-US' && intl.locale !== 'en') {
    const startFomattedDate = formatDate(intl, start, null, {
      intl: DATE_FORMAT.SHORT,
      fallback: DATE_FORMAT.SHORT_FALLBACK,
    });
    const endFormattedDate = formatDate(intl, end, null, {
      intl: DATE_FORMAT.SHORT,
      fallback: DATE_FORMAT.SHORT_FALLBACK,
    });
    return `${startFomattedDate} - ${endFormattedDate}`;
  }

  // For the US locale, we’ll do a simple "greatest difference" format.
  if (start.getFullYear() === end.getFullYear()) {
    if (start.getMonth() === end.getMonth()) {
      const startFormattedDate = formatDate(intl, start, null, {
        intl: { month: LONG, day: NUMERIC },
        fallback: 'MMMM d',
      });
      const endFormattedDay = formatDate(intl, end, null, {
        intl: { day: NUMERIC },
        fallback: 'd',
      });
      const formattedYear = formatDate(intl, end, null, { intl: { year: NUMERIC }, fallback: 'u' });
      return `${startFormattedDate} - ${endFormattedDay}, ${formattedYear}`;
    }
    const startFomattedDate = formatDate(intl, start, null, {
      intl: { month: LONG, day: NUMERIC },
      fallback: 'MMMM d',
    });
    const endFormattedDate = formatDate(intl, end, null, {
      intl: { month: LONG, day: NUMERIC, year: NUMERIC },
      fallback: 'P',
    });
    return `${startFomattedDate} - ${endFormattedDate}`;
  }
  const startFomattedDate = formatDate(intl, start, null, {
    intl: { month: LONG, day: NUMERIC, year: NUMERIC },
    fallback: 'P',
  });
  const endFormattedDate = formatDate(intl, end, null, {
    intl: { month: LONG, day: NUMERIC, year: NUMERIC },
    fallback: 'P',
  });
  return `${startFomattedDate} - ${endFormattedDate}`;
}
